/* istanbul ignore file */
const formattedGrowthBook = function () {
  const startGrowthBook = () => {
    if (!window.growthbook) return
    const { growthbook } = window
    const gb = new growthbook.GrowthBook({
      apiHost: 'https://cdn.growthbook.io',
      clientKey: 'sdk-n57cKky2HlaqH4I',
      enableDevMode: true,
      subscribeToChanges: true,
      trackingCallback: (experiment, result) => {
        // TODO: Use your real analytics tracking system
        /* eslint-disable */
        console.debug('Viewed Experiment', {
          experimentId: experiment.key,
          variationId: result.key,
        })
        /* eslint-disable */
      },
    })
    /* eslint-disable */
    console.info(
      '%c Load GrowthBook Features',
      'background: #036eb5; color: #fff; padding: 3px 6px;'
    )
    /* eslint-disable */
    gb.loadFeatures()
  }

  const alreadyLoaded =
    document?.querySelectorAll('[id="growthbook-sdk"]')?.length > 0

  const message = alreadyLoaded
    ? '%c GrowthBook previously loaded'
    : '%c Loading GrowthBook'
  console.info(message, 'background: #036eb5; color: #fff; padding: 3px 6px;') // eslint-disable-line)

  if (!alreadyLoaded) {
    const growthBookScript = document.createElement('script')
    growthBookScript.type = 'text/javascript'
    growthBookScript.id = 'growthbook-sdk'
    growthBookScript.src =
      'https://cdn.jsdelivr.net/npm/@growthbook/growthbook/dist/bundles/index.min.js'
    document.body.appendChild(growthBookScript)
    document
      ?.querySelector('#growthbook-sdk')
      .addEventListener('load', startGrowthBook)
  } else {
    startGrowthBook()
  }
}

export const getGrowthBookScript = () => `(${formattedGrowthBook.toString()}())`
